import { Row, Col, DatePicker, Form, Button, notification } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import TabContentWrapper from './TabContentWrapper';
import { useDownloadCenter } from '../../contexts/DownloadCenterContext';
import DownloadCardWrapper from './DownloadCardWrapper';
import DownloadCenterService from '../../services/DownloadCenterService';

import { useEffect } from 'react';

const { RangePicker } = DatePicker;

const reports = [
  {
    name: 'Block Trade Report',
    apiUrl: '/secured/block_trade_report',
  },
  // {
  //   name: 'Share Transfer Report',
  //   apiUrl: '/secured/share_transfer_report',
  // },
  {
    name: 'Order Book Report',
    apiUrl: '/secured/order_book_report',
  },
  {
    name: 'Trade Book Report',
    apiUrl: '/secured/trade_book_report',
  },
];

const ReportCard = ({ report, presetStartDate, presetEndDate }) => {
  const [noti, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const dateRange = Form.useWatch('dateRange', form);

  useEffect(() => {
    if (presetStartDate && presetEndDate) {
      form.setFieldsValue({ dateRange: [presetStartDate, presetEndDate] });
    }
  }, [presetStartDate, presetEndDate, form]);

  const onFinish = async ({ dateRange }) => {

    const startDate = dateRange[0].format('YYYYMMDD');
    const endDate = dateRange[1].format('YYYYMMDD');
    const fileName = `${report.name}_${startDate}_${endDate}`;

    console.log('payload format and file name', { startDate, endDate, fileName })

    const result = await DownloadCenterService.download(
      report.apiUrl,
      fileName,
      {
        startDate,
        endDate,
      },
    );

    if (!result.success) {
      noti.error({
        message: result.code || 'Download failed',
        description: result.message || 'Unknown error occurred',
        placement: 'topRight',
      });
    }
  };

  return (
    <Col xs={24} md={12}>
      {contextHolder}
      <DownloadCardWrapper
        tagMessage={'Date filter required'}
        title={report.name}
        description=""
        color={'warning'}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Report Date Range"
            name="dateRange"
            rules={[{ required: true, message: 'Please select a date range' }]}
          >
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            icon={<CloudDownloadOutlined />}
            disabled={!dateRange}
            block
          >
            Download
          </Button>
        </Form>
      </DownloadCardWrapper>
    </Col>
  );
};

const DateFilteredReport = () => {
  const { startDate, endDate } = useDownloadCenter();

  return (
    <TabContentWrapper
      title="Date Filtered Reports"
      text="Can customize date parameters for each reports separately"
    >
      <Row gutter={[16, 16]}>
        {reports.map(report => (
          <ReportCard
            key={report.apiUrl}
            report={report}
            presetStartDate={startDate}
            presetEndDate={endDate}
          />
        ))}
      </Row>
    </TabContentWrapper>
  );
};

export default DateFilteredReport;
